import scrollTriggers from 'scroll-triggers';
import { Fancybox } from "@fancyapps/ui";

scrollTriggers([
  {
    className: 'xyz-nested',
    offset: -80,
  }
]);

Fancybox.bind("[data-fancybox]", {
  showClass: "f-scaleIn",
  hideClass: "f-scaleOut",
  Carousel: {
    transition: "fade",
  },
  Thumbs: false,
  Toolbar: {
    display: {
      left: ["infobar"],
      middle: [
        "zoomIn",
        "zoomOut",
      ],
      right: ["slideshow", "close"],
    },
  },
});

document.getElementById("openNav").addEventListener("click", () => {
  Fancybox.show([{ src: "#navMenu", type: "inline" }]);
}); 
document.getElementById("closeMenu").addEventListener("click", () => {
  Fancybox.close();
}); 